export enum AppRouterName {
  Home = "/",
  ProductDetail = "/productDetail",
  SampleDetail = "/sampleDetail",
  VipCenter = "/vipCenter",
  HigherComm = "/higherComm",
  AdTaskDetailPage = "/adTaskDetailPage",
  AdTaskDetailInfoPage = "/adTaskDetailInfoPage",
  Wallet = "/wallet",
  MashupSelectScript = "/mashupSelectScript",
}

export enum AppSource {
  Tenjin = "tenjin",
  PcScan = "pc_scan",
  ShareApp = "share_app",
  App = "app",
}

export enum AppUrlType {
  H5 = "h5",
  App = "app",
}
